import RaiseFundApplication from "src/components/feature/RaiseFundApplication";

const DefaultFillFundApplication = () => {
  return <RaiseFundApplication />;
};

export default DefaultFillFundApplication;
